import { render, staticRenderFns } from "./DocumentSynthesisModal.vue?vue&type=template&id=a78d2bcc"
import script from "./DocumentSynthesisModal.vue?vue&type=script&lang=ts"
export * from "./DocumentSynthesisModal.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSynthesisModal.vue?vue&type=style&index=0&id=a78d2bcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports